import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class DicProjectdatatypeApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'dicProjectdatatype'
    }


    /**
     * 查询数据类别列表
     * @returns 
     */
    public getList(params){
        return this.send(params,"getList",Methods.GET)
    }

    /**
     * 查询数据分页列表
     * @param params
     */
    public getListPage(params){
        return this.send(params,"getEntitiesPage",Methods.GET)
    }

}